import { Stack, Typography, Button } from '@mui/material';

interface ComponentProps {
  actionLabel: string;
  message: string;
  handleAction: (e: any) => any;
}

const FormErrorMessage = ({
  actionLabel,
  message,
  handleAction,
}: ComponentProps) => {
  return (
    <Stack spacing={3} justifyContent="center" alignItems="center">
      <Typography variant="h6" paddingInline="20rem" textAlign="justify">
        {message}
      </Typography>
      <Button
        sx={{ mx: 15 }}
        variant="contained"
        color="secondary"
        onClick={handleAction}
      >
        {actionLabel}
      </Button>
    </Stack>
  );
};

export default FormErrorMessage;
